import { ACCOUNT_PROVIDER_ID, type AccountInfo } from '@/composables/accounts/providers/types';

class AccountProviderInterface {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async init(_onAccountChangeHandler: (accountInfo: AccountInfo, providerId: ACCOUNT_PROVIDER_ID) => void): Promise<void> {
    throw new Error("Method 'init()' must be implemented.");
  }

  async connect(): Promise<void> {
    throw new Error("Method 'connect()' must be implemented.");
  }

  async disconnect(): Promise<void> {
    throw new Error("Method 'disconnect()' must be implemented.");
  }

  /**
   * Optional: Opens account settings/management modal (if supported by provider)
   * Currently only implemented by Reown provider
   */
  async openAccountSettings?(): Promise<void>;

  /**
   * Ensures the user is on the correct network for blockchain interactions.
   * Should be called before any contract calls or transactions.
   * Throws if user rejects network switch or if switching fails.
   */
  async ensureCorrectNetwork(): Promise<void> {
    throw new Error("Method 'ensureCorrectNetwork()' must be implemented.");
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountBalance(_accountId: string, _tokenId: string): Promise<string> {
    throw new Error("Method 'getAccountBalance()' must be implemented.");
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountInfo(_accountId: string): Promise<AccountInfo> {
    throw new Error("Method 'getAccountInfo()' must be implemented.");
  }
}

export default AccountProviderInterface;
